module.exports = __webpack_public_path__ + "static/28-b72382c1ab9e7a0882a5a515d593ce8d.png";